import api from '../api';
import { GetUserResponse } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useGetUser = () => {
  const user = ref<GetUserResponse | null>(null);
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);
  const loadUser = async (userUid: string): Promise<GetUserResponse | null> => {
    try {
      isLoading.value = true;
      const response = await api.user.get(userUid);
      user.value = response.data;
    } catch (err: unknown) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

    return user.value;
  };

  return {
    loadUser,
    isLoading,
    user,
    error,
  };
};
